<template>
  <div class="experience">
    <div class="cjh-title" v-if="!isDis">
      科研能力和学术水平
      <div class="tip">本页内容为入库审核条件，请完整填写相关内容。</div>
    </div>
    <div class="cjh-cnt">
      <el-form
        ref="formRef"
        :model="ruleForm"
        :disabled="isDis || noEdit"
        label-width="140px"
        label-position="left"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="承担科技计划"
              prop="undertake_technology_plans"
              :rules="btRulesBtTitle"
            >
              <el-radio-group v-model="ruleForm.undertake_technology_plans">
                <el-radio label="是">是</el-radio>
                <!-- <el-radio label="否">否</el-radio> -->
              </el-radio-group>
              <div class="tip">
                承担过中央及地方财政支持的科技计划（专项、基金）项目（课题）
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.undertake_technology_plans === '是'">
          <el-col :span="24">
            <el-form-item
              label=" "
              prop="undertake_technology_plans_json"
              :rules="btRulesBt"
            >
              <div
                class="zl-item"
                v-for="(
                  item, index
                ) in ruleForm.undertake_technology_plans_json"
                :key="index"
              >
                <i
                  v-if="!isDis && !noEdit"
                  class="el-icon-delete icon-btn"
                  slot="reference"
                  @click="handleDel('undertake_technology_plans_json', index)"
                ></i>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="项目名称">
                      <el-input
                        v-model="item.prjName"
                        placeholder="请输入项目（课题/任务）名称"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="项目类别">
                      <el-cascader
                        filterable
                        v-model="item.prjType"
                        :options="prjList"
                        style="width: 100%"
                        clearable
                        :props="{ label: 'name', value: 'name' }"
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="项目来源">
                      <el-input
                        v-model="item.source"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="起始年月">
                      <el-date-picker
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        v-model="item.startDate"
                        type="month"
                        placeholder="请选择"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="截止年月">
                      <div class="endDate-warp">
                        <jzDate
                          :endTime.sync="item.endDateDate"
                          :formTimeYz.sync="item.endDate"
                          :nowFlag.sync="item.endDateNow"
                          :isDis="isDis || noEdit"
                        ></jzDate>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="项目额度(万元)">
                      <el-input
                        v-model="item.money"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="在本项目中承担的主要工作">
                      <div class="endDate-warp">
                        <el-select
                          v-model="item.workMain"
                          placeholder="请选择"
                          style="width: 100%"
                          clearable
                          filterable
                        >
                          <el-option
                            :label="item"
                            :value="item"
                            v-for="(item, index) in zygzList"
                            :key="index"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-button
                type="primary"
                size="medium"
                v-if="
                  ruleForm.undertake_technology_plans_json.length < 5 && !isDis && !noEdit
                "
                @click="ruleForm.undertake_technology_plans_json.push({})"
                >添加新数据</el-button
              >
              <div class="tip">请填写您承担的科研项目（限5项）</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="获奖情况"
              prop="provincial_ministerial_level"
              :rules="btRulesBtTitle"
            >
              <el-radio-group v-model="ruleForm.provincial_ministerial_level">
                <el-radio label="是">是</el-radio>
                <!-- <el-radio label="否">否</el-radio> -->
              </el-radio-group>
              <div class="tip">
                国家科学技术奖励获得者、省部级科学技术奖励（二等奖及以上奖项的前三完成人）、社会力量奖（二等奖及以上前三完成人）
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.provincial_ministerial_level === '是'">
          <el-col :span="24">
            <el-form-item
              label=" "
              prop="provincial_ministerial_level_json"
              :rules="btRulesBt"
            >
              <div
                class="zl-item"
                v-for="(
                  item, index
                ) in ruleForm.provincial_ministerial_level_json"
                :key="index"
              >
                <i
                  v-if="!isDis && !noEdit"
                  class="el-icon-delete icon-btn"
                  slot="reference"
                  @click="handleDel('provincial_ministerial_level_json', index)"
                ></i>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="奖项名称">
                      <el-input
                        v-model="item.name"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="获奖年份">
                      <el-date-picker
                        style="width: 100%"
                        format="yyyy"
                        value-format="yyyy"
                        v-model="item.year"
                        type="year"
                        placeholder="请选择"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="奖励等级">
                      <el-select
                        v-model="item.level"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                        filterable
                      >
                        <el-option
                          :label="item"
                          :value="item"
                          v-for="(item, index) in jldjList"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="奖励种类">
                      <el-select
                        v-model="item.typeName"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                        filterable
                      >
                        <el-option
                          :label="item"
                          :value="item"
                          v-for="(item, index) in jlzlList"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="获奖人排序"
                      :prop="'provincial_ministerial_level_json.' + index + '.sort'"
                      :rules="sortRules"
                    >
                      <el-input
                        v-model="item.sort"
                        placeholder="1/10"
                        clearable
                        @blur="validateSortFormat(item, '获奖人排序')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="授奖机构">
                      <el-input
                        v-model="item.org"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-button
                type="primary"
                size="medium"
                v-if="
                  ruleForm.provincial_ministerial_level_json.length < 3 &&
                  !isDis && !noEdit
                "
                @click="ruleForm.provincial_ministerial_level_json.push({})"
                >添加新数据</el-button
              >
              <!-- <div class="tip">请填写相关内容并上传证明材料（限3项）</div> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="参与标准制定"
              prop="participate_standard_setting"
              :rules="btRules"
            >
              <el-radio-group v-model="ruleForm.participate_standard_setting">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
              <div class="tip">国际（国家）标准的主要完成人</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.participate_standard_setting === '是'">
          <el-col :span="24">
            <el-form-item
              label="参与标准制定情况"
              prop="participate_standard_setting_json"
              :rules="btRules"
            >
              <div
                class="zl-item"
                v-for="(
                  item, index
                ) in ruleForm.participate_standard_setting_json"
                :key="index"
              >
                <i
                  v-if="!isDis && !noEdit"
                  class="el-icon-delete icon-btn"
                  slot="reference"
                  @click="handleDel('participate_standard_setting_json', index)"
                ></i>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="标准名称">
                      <el-input
                        v-model="item.name"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="标准类型">
                      <el-select
                        v-model="item.type"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                        filterable
                      >
                        <el-option
                          label="国际标准"
                          value="国际标准"
                        ></el-option>
                        <el-option
                          label="国家标准"
                          value="国家标准"
                        ></el-option>
                        <el-option
                          label="团体标准"
                          value="团体标准"
                        ></el-option>
                        <el-option
                          label="行业标准"
                          value="行业标准"
                        ></el-option>
                        <el-option
                          label="地方标准"
                          value="地方标准"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="标准号">
                      <el-input
                        v-model="item.sno"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="标准指定人">
                      <el-input
                        v-model="item.pname"
                        placeholder="1/10"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="标准发布机构">
                      <el-input
                        v-model="item.org"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="标准发布日期">
                      <el-date-picker
                        v-model="item.fdate"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                        type="date"
                        placeholder="选择日期"
                        clearable
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-button
                type="primary"
                size="medium"
                v-if="
                  ruleForm.participate_standard_setting_json.length < 8 &&
                  !isDis && !noEdit
                "
                @click="ruleForm.participate_standard_setting_json.push({})"
                >添加新数据</el-button
              >
              <div class="tip">请填写相关内容（限8项）</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="重要任职"
              prop="position_important"
              :rules="btRules"
            >
              <el-radio-group v-model="ruleForm.position_important">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
              <div class="tip">
                担任全国学会理事或分支机构负责人，或在国际学术组织担任高级职务，或在企业担任科技负责人
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.position_important === '是'">
          <el-col :span="24">
            <el-form-item
              label="重要任职经历"
              prop="position_important_json"
              :rules="btRules"
            >
              <div
                class="zl-item"
                v-for="(item, index) in ruleForm.position_important_json"
                :key="index"
              >
                <i
                  class="el-icon-delete icon-btn"
                  slot="reference"
                  @click="handleDel('position_important_json', index)"
                  v-if="!isDis && !noEdit"
                ></i>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="起始年月">
                      <el-date-picker
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        v-model="item.startDate"
                        type="month"
                        placeholder="请选择"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="截止年月">
                      <div class="endDate-warp">
                        <jzDate
                          :endTime.sync="item.endDateDate"
                          :formTimeYz.sync="item.endDate"
                          :nowFlag.sync="item.endDateNow"
                          :isDis="isDis || noEdit"
                        ></jzDate>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="组织名称">
                      <el-input
                        v-model="item.org"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="职务">
                      <el-input
                        v-model="item.position"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-button
                type="primary"
                size="medium"
                v-if="ruleForm.position_important_json.length < 5 && !isDis && !noEdit"
                @click="ruleForm.position_important_json.push({})"
                >添加新数据</el-button
              >
              <div class="tip">请按时间先后顺序填写（限5项）</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="参与重大工程"
              prop="participate_major_projects"
              :rules="btRules"
            >
              <el-radio-group v-model="ruleForm.participate_major_projects">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
              <div class="tip">
                在工程技术方面取得重大的、创造性的成果和做出贡献，并有显著应用成效
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.participate_major_projects === '是'">
          <el-col :span="24">
            <el-form-item
              label="工程项目情况"
              prop="participate_major_projects_json"
              :rules="btRules"
            >
              <div
                class="zl-item"
                v-for="(
                  item, index
                ) in ruleForm.participate_major_projects_json"
                :key="index"
              >
                <i
                  class="el-icon-delete icon-btn"
                  slot="reference"
                  @click="handleDel('participate_major_projects_json', index)"
                  v-if="!isDis && !noEdit"
                ></i>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="项目名称">
                      <el-input
                        v-model="item.name"
                        placeholder="请输入项目（课题/任务）名称"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="经费（万元）">
                      <el-input
                        v-model="item.money"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="起始年月">
                      <el-date-picker
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        v-model="item.startDate"
                        type="month"
                        placeholder="请选择"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="截止年月">
                      <div class="endDate-warp">
                        <jzDate
                          :endTime.sync="item.endDateDate"
                          :formTimeYz.sync="item.endDate"
                          :nowFlag.sync="item.endDateNow"
                          :isDis="isDis || noEdit"
                        ></jzDate>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="项目来源">
                      <el-input
                        v-model="item.source"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="在本项目中承担的主要工作">
                      <el-select
                        v-model="item.workMain"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                        filterable
                      >
                        <el-option
                          :label="item"
                          :value="item"
                          v-for="(item, index) in zygzList2"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-button
                type="primary"
                size="medium"
                v-if="
                  ruleForm.participate_major_projects_json.length < 5 && !isDis && !noEdit
                "
                @click="ruleForm.participate_major_projects_json.push({})"
                >添加新数据</el-button
              >
              <div class="tip">请填写相关内容（限5项）</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="重要发明专利"
              prop="important_invention_patents"
              :rules="btRulesBtTitle"
            >
              <el-radio-group v-model="ruleForm.important_invention_patents">
                <el-radio label="是">是</el-radio>
                <!-- <el-radio label="否">否</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.important_invention_patents === '是'">
          <el-col :span="24">
            <el-form-item
              label="授权专利情况"
              prop="important_invention_patents_json"
              :rules="btRulesBt"
            >
              <div
                class="zl-item"
                v-for="(
                  item, index
                ) in ruleForm.important_invention_patents_json"
                :key="index"
              >
                <i
                  class="el-icon-delete icon-btn"
                  slot="reference"
                  @click="handleDel('important_invention_patents_json', index)"
                  v-if="!isDis && !noEdit"
                ></i>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="专利名称">
                      <el-input
                        v-model="item.name"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="专利国家">
                      <el-input
                        v-model="item.country"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                      <!-- <el-select
                        v-model="item.country"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                        filterable
                      >
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                      </el-select> -->
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="发明人排序"
                      :prop="'important_invention_patents_json.' + index + '.sort'"
                      :rules="sortRules"
                    >
                      <el-input
                        v-model="item.sort"
                        placeholder="1/10"
                        clearable
                        @blur="validateSortFormat(item, '发明人排序')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="授权专利号">
                      <el-input
                        v-model="item.sno"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="专利授权日">
                      <el-date-picker
                        v-model="item.zdate"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                        type="date"
                        placeholder="选择日期"
                        clearable
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="专利关键词">
                      <el-input
                        v-model="item.keyword"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-button
                type="primary"
                size="medium"
                v-if="
                  ruleForm.important_invention_patents_json.length < 5 && !isDis && !noEdit
                "
                @click="ruleForm.important_invention_patents_json.push({})"
                >添加新数据</el-button
              >
              <!-- <div class="tip">请填写相关内容并上传证明材料（限5项）</div> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btn-warp" v-if="!isDis && !noEdit">
      <el-button type="primary" plain class="btn" @click="handleSaveZc"
        >暂存数据</el-button
      >
      <el-button type="primary" class="btn" @click="handleSave">保存</el-button>
    </div>
  </div>
</template>
<script>
import jzDate from './components/jzDate.vue'
import { update_data, getUserInfo } from '../../axios/api'
import prjType from './json/prjType.json'
export default {
  props: {
    isDis: {
      type: Boolean,
      default: false
    }
  },
  components: {
    jzDate
  },
  data () {
    return {
      prjList: prjType,
      jlzlList: ['自然科学', '科技进步', '技术发明', '其他'],
      jldjList: [
        '国际学术奖',
        '国家一等奖',
        '国家二等奖',
        '省部特等奖',
        '省部一等奖',
        '省部二等奖',
        '社会力量一等奖',
        '社会力量二等奖',
        '人物奖'
      ],
      zlList: [
        '中国专利',
        '美国专利',
        '欧洲专利',
        'WIPO专利',
        '日本专利',
        '其他国家专利',
        '其他'
      ],
      zygzList: [
        '项目负责人',
        '项目成员作为负责人',
        '承担过中央财政支持的科技计划（专项、基金）项目（课题）'
      ],
      zygzList2: ['项目负责人', '项目成员'],
      btRules: [
        { required: false, message: '必填', trigger: ['blur', 'change'] }
      ],
      btRulesBtTitle: [
        { required: true, message: '必填', trigger: ['blur', 'change'] },
        {
          validator: (_rule, value, callback) => {
            if (!value) {
              callback(new Error('请选择是或否'))
              return
            }
            if (value !== '是') {
              callback(new Error('必须选择"是"'))
              return
            }
            callback()
          },
          trigger: ['blur', 'change']
        }
      ],
      btRulesBt: [
        { required: true, message: '必填', trigger: ['blur', 'change'] }
      ],
      sortRules: [
        {
          validator: (_rule, value, callback) => {
            if (!value) {
              callback()
              return
            }
            const sortPattern = /^\d+\/\d+$/
            if (!sortPattern.test(value)) {
              callback(new Error('请输入X/Y格式，X、Y为数字'))
            } else {
              callback()
            }
          },
          trigger: ['blur', 'change']
        }
      ],
      ruleForm: {
        undertake_technology_plans: '',
        provincial_ministerial_level: '',
        participate_standard_setting: '',
        position_important: '',
        participate_major_projects: '',
        important_invention_patents: '',
        undertake_technology_plans_json: [],
        provincial_ministerial_level_json: [],
        participate_standard_setting_json: [],
        position_important_json: [],
        participate_major_projects_json: [],
        important_invention_patents_json: []
      },
      noEdit: false
    }
  },
  mounted () {
    if (this.isDis) {
      this.ruleForm = sessionStorage.getItem('cjhuser')
        ? JSON.parse(sessionStorage.getItem('cjhuser'))
        : {}
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
    } else {
      this.ruleForm = sessionStorage.getItem('uinfo')
        ? JSON.parse(sessionStorage.getItem('uinfo'))
        : {}
      if (this.ruleForm.is_submit == 1 || this.ruleForm.is_submit == 4) {
        // 已提交就不可编辑，已审核也不可再编辑, 只有未提交和驳回才可编辑
        this.noEdit = true
      }
    }
    this.ruleForm.undertake_technology_plans = '是'
    this.ruleForm.provincial_ministerial_level = '是'
    this.ruleForm.important_invention_patents = '是'
    this.ruleForm.participate_standard_setting =
      this.ruleForm.participate_standard_setting || '否'
    this.ruleForm.position_important = this.ruleForm.position_important || '否'
    this.ruleForm.participate_major_projects =
      this.ruleForm.participate_major_projects || '否'
    this.ruleForm.undertake_technology_plans_json = this.ruleForm
      .undertake_technology_plans_json
      ? JSON.parse(this.ruleForm.undertake_technology_plans_json)
      : []
    this.ruleForm.provincial_ministerial_level_json = this.ruleForm
      .provincial_ministerial_level_json
      ? JSON.parse(this.ruleForm.provincial_ministerial_level_json)
      : []
    this.ruleForm.participate_standard_setting_json = this.ruleForm
      .participate_standard_setting_json
      ? JSON.parse(this.ruleForm.participate_standard_setting_json)
      : []
    this.ruleForm.position_important_json = this.ruleForm
      .position_important_json
      ? JSON.parse(this.ruleForm.position_important_json)
      : []
    this.ruleForm.participate_major_projects_json = this.ruleForm
      .participate_major_projects_json
      ? JSON.parse(this.ruleForm.participate_major_projects_json)
      : []
    this.ruleForm.important_invention_patents_json = this.ruleForm
      .important_invention_patents_json
      ? JSON.parse(this.ruleForm.important_invention_patents_json)
      : []
  },
  methods: {
    saveFun () {
      const params = {
        ...this.ruleForm,
        token: sessionStorage.getItem('Token3')
      }
      params.undertake_technology_plans_json = params
        .undertake_technology_plans_json?.length
        ? JSON.stringify(params.undertake_technology_plans_json)
        : ''
      params.provincial_ministerial_level_json = params
        .provincial_ministerial_level_json?.length
        ? JSON.stringify(params.provincial_ministerial_level_json)
        : ''
      params.participate_standard_setting_json = params
        .participate_standard_setting_json?.length
        ? JSON.stringify(params.participate_standard_setting_json)
        : ''
      params.position_important_json = params.position_important_json?.length
        ? JSON.stringify(params.position_important_json)
        : ''
      params.participate_major_projects_json = params
        .participate_major_projects_json?.length
        ? JSON.stringify(params.participate_major_projects_json)
        : ''
      params.important_invention_patents_json = params
        .important_invention_patents_json?.length
        ? JSON.stringify(params.important_invention_patents_json)
        : ''
      update_data({ ...params }).then((ress) => {
        if (ress.data.code === 200) {
          getUserInfo({ token: sessionStorage.getItem('Token3') }).then(
            (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                sessionStorage.setItem('uinfo', JSON.stringify(res.data.data))
              }
            }
          )
        }
      })
    },
    handleSaveZc () {
      this.saveFun()
    },
    handleSave () {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.saveFun()
        } else {
          console.log('error submit!!')
          this.$message({
            message: '请重新检查填写，必填项不能为空',
            type: 'error'
          })
          return false
        }
      })
    },
    // 确定删除
    handleDel (attr, index) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.ruleForm[attr].splice(index, 1)
        })
        .catch(() => {})
    },
    // 验证排序格式
    validateSortFormat (item, fieldName) {
      if (item.sort) {
        const sortPattern = /^\d+\/\d+$/
        if (!sortPattern.test(item.sort)) {
          this.$message({
            message: `${fieldName}格式不正确，请输入X/Y格式，X、Y为数字`,
            type: 'warning'
          })
          item.sort = ''
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.experience {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }
  .cjh-cnt {
    flex: 1;
    overflow-y: auto;
    padding: 20px 25px;
  }
  .cjh-title {
    padding: 20px 25px;
    border-bottom: 1px solid rgba(220, 220, 220, 0.5);
    font-weight: 600;
    font-size: 20px;
    .tip {
      font-size: 16px;
      font-weight: 400;
      margin-top: 5px;
    }
  }
  .btn-warp {
    background: #fff;
    padding: 30px 50px;
    left: 0;
    bottom: 0;
    .btn {
      height: 42px;
    }
  }
  .tip {
    color: #999;
  }
  .zl-item {
    border: 1px solid #eee;
    padding: 20px;
    position: relative;
    background-color: #f9f9f9;
    margin-bottom: 10px;
    .icon-btn {
      cursor: pointer;
      font-size: 20px;
      position: absolute;
      top: 2px;
      right: 2px;
    }
  }
}
</style>
<style lang="less">
.el-form-item__content .el-input-number .el-input input {
  text-align: left !important;
}
</style>
